import React from 'react'
import './display.css'
import Chef from '../../Images/Larger devices/Rectangle.png'
import Food from '../../Images/Larger devices/Rectangle (1).png'
import Card from '../../Images/Larger devices/Rectangle (2).png'

function Display() {
  return (
    <div className='forg'>
        <div className="row hit">
            <div className='col-sm-12 col-md-12 col-lg-4'>
                <img className='tok' src={Chef} alt='' />
            </div>
            <div className='col-sm-12 col-md-12 col-lg-8'>
                <div className='dan tik'>
                    <h3 className='lin'>Create an account</h3>
                    <h2 className='frd'>Create/login to an existing <br/> account to get started</h2>
                    <h4 className='exc'>An account is created with your email <br/> and a desired password</h4>
                </div>
            </div>
        </div>
        <div className="row">
            <div className='col-sm-12 col-md-12 col-lg-8'>
            <div className='dano'>
                    <h3 className='lin'>Explore varieties</h3>
                    <h2 className='frd'>Shop for your favorites <br/> meal as e dey hot.</h2>
                    <p className='exc'>Shop for your favorite meals or drink <br/> sand enjoy while doing it.</p>
                </div>
            </div>
            <div className='col-sm-12 col-md-12 col-lg-4 dani'>
            <img src={Food} alt='' />
            </div>
        </div>
        <div className="row hit">
            <div className='col-sm-12 col-md-12 col-lg-4 att'>
                <img src={Card} alt='' />
            </div>
            <div className='col-sm-12 col-md-12 col-lg-8'>
                <div className='dan tvc'>
                    <h3 className='lin'>Checkout</h3>
                    <h2 className='frd'>When you done check out <br/> and get it delivered.</h2>
                    <h4 className='exc'>When you done check out and get it <br/> delivered with ease.</h4>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Display
